import popupAlert from '../react/components/PopupAlert/mount';
import offlineWarning from '../react/features/OfflineWarning/mount';

export type Mount = {
    Component: React.FC<{ mountNode: HTMLElement }>;
    id: string;
};

const mounts: Mount[] = [popupAlert, offlineWarning];

export default mounts;
